/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - David Pistori <dp@indigen.com>
 *   - Loay Hatem <lh@indigen.com>
 *   - Peter Magdy <pm@indigen.com>
 * NOTICE: All information contained here is, and remains
 * the property of Indigen Solutions and its suppliers, if any.
 *
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

import * as React from "react";

const BlueLem: any = (props: {}) => {
  return (
    <svg width="99" height="174" viewBox="0 0 99 174" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.345 50.5792C63.9264 50.5792 87.6 69.5008 87.6 102.206C87.6 132.518 62.87 153.834 31.345 153.834C-1.5396 153.834 -23.2942 132.682 -24.9223 99.1132C-26.3342 69.9095 -8.7406 19.1442 47.8673 0L50.6968 5.57614C35.6875 15.8435 24.072 31.9615 22.5308 42.2739C21.0983 51.865 28.7541 50.5792 31.345 50.5792Z"
        fill="#81D3E7"
      />
      <path
        d="M72.7205 113.573C69.2298 125.856 70.615 139.51 76.889 154.643L46.7135 171.784C34.1693 156.141 30.6965 131.452 36.2863 107.728C41.8812 83.9814 56.507 61.4274 79.8499 50.131L97.4067 81.0847C84.5274 90.5299 76.2087 101.299 72.7205 113.573Z"
        stroke="#402316"
        strokeWidth="2"
      />
    </svg>
  );
};

export default BlueLem;
